import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import MapRoundedIcon from "@mui/icons-material/MapRounded";
import TableRestaurantRoundedIcon from "@mui/icons-material/TableRestaurantRounded";
import StepZonas from "./StepZonas";
import StepMesas from "./StepMesas";

// Wizard · Step "Local" agrupador. Zonas + Mesas en tabs. Antes eran
// 2 steps separados. Fusionarlos tiene sentido semántico (primero
// zonas, luego mesas por zona) y reduce el count del wizard.

const TABS = [
  { key: "zonas", label: "Zonas", icon: <MapRoundedIcon fontSize="small" />, component: StepZonas },
  { key: "mesas", label: "Mesas", icon: <TableRestaurantRoundedIcon fontSize="small" />, component: StepMesas },
];

export default function StepLocal({ progress, onComplete, onSkip }) {
  const [tab, setTab] = useState("zonas");
  const Active = TABS.find((t) => t.key === tab)?.component || StepZonas;

  // "Continuar"/"Saltar" avanzan de tab en tab; solo cierran el step
  // wrapper cuando estamos en la última tab (Mesas).
  const currentIdx = TABS.findIndex((t) => t.key === tab);
  const isLastTab = currentIdx === TABS.length - 1;
  const handleInnerComplete = (extra) => {
    if (!isLastTab) return setTab(TABS[currentIdx + 1].key);
    onComplete?.(extra);
  };
  const handleInnerSkip = () => {
    if (!isLastTab) return setTab(TABS[currentIdx + 1].key);
    onSkip?.();
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
        Configura tu local
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 3 }}>
        Primero añade las zonas (terraza, barra, salón…) y después define
        cuántas mesas hay en cada una. Puedes reajustar todo desde el plano
        de mesas del portal.
      </Typography>

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="fullWidth"
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        {TABS.map((t) => (
          <Tab
            key={t.key}
            value={t.key}
            icon={t.icon}
            iconPosition="start"
            label={t.label}
            sx={{ fontWeight: 700, minHeight: 48 }}
          />
        ))}
      </Tabs>

      <Active
        progress={progress}
        onComplete={handleInnerComplete}
        onSkip={handleInnerSkip}
      />
    </Box>
  );
}
